import $ from 'jquery'

export class CalculatorFreelance {

  constructor() {
    this.$container = $('.calculator-freelance')

    if (!this.$container.length) return

    this.$form = this.$container.find('form')
    this.$inputs = this.$form.find('input')
    this.$containerWithResult = this.$container.find('.with-results')
    this.$containerWithoutResult = this.$container.find('.no-result')
    this.$monthInput = this.$container.find('#month')

    this.$quotaInput = this.$container.find('#contribution')
    this.$childrenInput = this.$container.find('#children')
    this.data = {
      quotaMin: 200,
      quotaMax: 1540,
      baseFactor: 0.315,
      rate: 0.7,
      iprem2025: 600
    }

    this.$benefitMonths = this.$container.find('#text-month')
    this.$monthlyAmount = this.$container.find('#text-contribution')
    this.$totalAmount = this.$container.find('#text-total')
    this.$error = this.$container.find('.calc-error')

    this.$form.on('change', this.handleChangeForm.bind(this))
    this.$form.on('input', this.handleSubmitForm.bind(this))
    this.$inputs.on('keyup', this.handleChangeForm.bind(this))
  }

  handleSubmitForm(e) {
    e.preventDefault()

    this.handleChangeForm()
  }

  handleChangeForm() {
    this.$containerWithResult.show()
    this.$containerWithoutResult.hide()

    let monthsContributed = this.toInt(this.$monthInput.find(':selected').val())
    let quota = this.toFloat(this.$quotaInput.val())

    // children select values: 0,1,2 (where 2 means 2+)
    let childrenRaw = this.toInt(this.$childrenInput.val())
    let childrenCount = childrenRaw >= 2 ? 2 : childrenRaw

    // validate quota
    if (quota > this.data.quotaMax) {
      this.$error.show()

      this.applyValue(this.$benefitMonths, '—')
      this.applyValue(this.$monthlyAmount, '—')
      this.applyValue(this.$totalAmount, '—')

      return
    }

    this.$error.hide()

    if (monthsContributed === 0) {
      this.$containerWithResult.hide()
      this.$containerWithoutResult.show()

      return
    }

    // quota min info (not an error per your spec, just clamp for safety)
    let safeQuota = Math.max(0, quota)

    let calc = this.computeMonthlyAmountFromQuota(safeQuota, childrenCount)
    let monthly = this.round2(calc.result)
    let total = this.round2(monthly * monthsContributed)

    this.applyValue(this.$benefitMonths, monthsContributed)
    this.applyValue(this.$monthlyAmount, monthly)
    this.applyValue(this.$totalAmount, total)
  }

  toInt(v) {
    let n = parseInt(String(v), 10)
    return Number.isFinite(n) ? n : 0
  }

  toFloat(v) {
    let n = parseFloat(String(v))
    return Number.isFinite(n) ? n : 0
  }

  round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100
  }

  applyValue($el, value) {
    if (!$el || !$el.length) return
    let template = $el.data('value') || '%%value%%'
    $el.text(String(template).replace('%%value%%', value))
  }

  getLimits(childrenCount) {
    let iprem = this.data.iprem2025

    if (childrenCount <= 0) {
      return {min: 0.8 * iprem, max: 1.75 * iprem} // 480 / 1050
    }

    if (childrenCount === 1) {
      return {min: 1.07 * iprem, max: 2.0 * iprem} // 642 / 1200
    }

    // 2 or more
    return {min: 1.07 * iprem, max: 2.25 * iprem} // 642 / 1350
  }

  computeMonthlyAmountFromQuota(quota, childrenCount) {
    // 1) Base
    let base = quota / this.data.baseFactor

    // 2) Theoretical
    let theoretical = base * this.data.rate

    // 3) Limits
    let {min, max} = this.getLimits(childrenCount)

    // 4) Apply floors/ceilings
    let result = Math.min(Math.max(theoretical, min), max)

    return {
      base,
      theoretical,
      min,
      max,
      result
    }
  }
}
